import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import s from './Clients.scss';

export function Clients() {
	useStyles(s);

	return (
		<div className="sl-teams-clients">
			<div className="sl-teams-clients__text">
				Proudly teaching learners at:
			</div>
			<div className="sl-teams-clients__logos">
				{[
					'amazon-logo',
					'google-logo',
					'apple-logo',
					'glovo-logo',
					'spacex-logo',
				].map((companyLogo) => (
					<div
						className="sl-teams-clients__logo"
						id={companyLogo}
						key={companyLogo}
					>
						<img
							src={`https://blob.sololearn.com/web-assets/${companyLogo}.png`}
							alt={companyLogo}
						/>
					</div>
				))}
			</div>
		</div>
	);
}
